import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost";
type Size = "sm" | "md";

const STYLES: Record<Variant, string> = {
	primary: "bg-ink text-ground font-semibold hover:opacity-90",
	secondary: "border border-hairline bg-paper text-ink hover:border-line hover:bg-raised",
	ghost: "text-muted hover:bg-raised hover:text-ink",
};

const SIZES: Record<Size, string> = {
	sm: "h-7 px-2.5 text-xs gap-1.5",
	md: "min-h-tap px-3 text-[13px] gap-1.5",
};

/**
 * `primary` is deliberately ink, not a state colour — state hues are reserved
 * for state, and foil is reserved for buyable. One primary action per screen.
 */
export function Button({
	variant = "secondary",
	size = "md",
	className = "",
	...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }) {
	return (
		<button
			{...rest}
			className={`inline-flex items-center justify-center rounded-md font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 ${SIZES[size]} ${STYLES[variant]} ${className}`}
		/>
	);
}
